<template>
  <b-modal
    id="generate-sticker-pdf"
    ref="generate-sticker-pdf"
    hide-footer
    centered
    content-class="rounded-8"
    @hide="clear"
  >
    <div class="mt-n5">
      <BlockHeader name="Generate PDF" />
      <div class="row">
        <div class="col-lg-6 col-sm-6 col-xs-6">
          <Select v-model="selectedCompany" placeholder="Company" :options="companies" class="mb-0" />
        </div>
        <div class="col-lg-6 col-sm-6 col-xs-6 pt-1">
          <b-button
            variant="outline-primary"
            size="lg"
            class="px-4 mt-4"
            :disabled="!selectedCompany"
            @click="() => {
              onGeneratePdf(selectedCompany);
              $bvModal.hide('generate-sticker-pdf');  
            }"
          >
            {{ 'Generate PDF' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Select from '../../common/select';
import BlockHeader from '../../common/block-header';

export default {
  name: 'SelectCompanyModal',
  components: { Select, BlockHeader },
  props: {
    onGeneratePdf: {
      type: Function,
      default: () => {},
    },
    companies: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      selectedCompany: null,
    };
  },
  methods: {
    clear() {
      this.selectedCompany = null;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
::v-deep .line-height-28 {
  line-height: 28px;
}
</style>
